import { render, staticRenderFns } from "./EditAccessPoint.vue?vue&type=template&id=6912560a&scoped=true"
import script from "./EditAccessPoint.vue?vue&type=script&lang=js"
export * from "./EditAccessPoint.vue?vue&type=script&lang=js"
import style0 from "./EditAccessPoint.vue?vue&type=style&index=0&id=6912560a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6912560a",
  null
  
)

export default component.exports